import { ActivityCategory } from '@/entities/activities/ActivityCategory'
import { ReservationMethod } from '@/entities/activities/ReservationMethod'
import { PageObjectLocation } from '@/entities/webapp-pages/page-objects/Location'
import camelcaseKeys from 'camelcase-keys'
export class UpcomingEvent {
  constructor (params = {}) {
    const { pageId, start, end, date, title, activityCategory, reservationMethods, location } = params ? camelcaseKeys(params, { deep: true }) : {}

    this.pageId = pageId || null
    this.start = start || 0
    this.end = end || 0
    this.date = date || null
    this.title = title || []
    this.activityCategory = activityCategory ? new ActivityCategory(activityCategory) : null
    this.reservationMethods = reservationMethods ? reservationMethods.map((rM) => {
      return new ReservationMethod(rM)
    }) : []
    this.location = location ? new PageObjectLocation(location) : null
  }
}
  